import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const auth  = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const apiMessage: string | undefined = error.error?.message;

      if (error.status === 0) {
        toast.error('No connection', 'Cannot reach the server. Please check your network.', 0);
        return throwError(() => error);
      }

      if (error.status === 401) {
        if (auth.isAuthenticated()) {
          // Token expired on a protected route — log out and show API message
          toast.warning('Session expired', apiMessage ?? 'Please sign in again.');
          auth.logout();
        } else {
          // Login attempt failed — just show the API message
          toast.error('Sign in failed', apiMessage);
        }
        return throwError(() => error);
      }

      if (apiMessage) {
        toast.error(`Error ${error.status}`, apiMessage);
      }

      return throwError(() => error);
    }),
  );
};
